import { render, staticRenderFns } from "./PublicOfficialsSection.vue?vue&type=template&id=c3187f64&scoped=true"
import script from "./PublicOfficialsSection.vue?vue&type=script&lang=js"
export * from "./PublicOfficialsSection.vue?vue&type=script&lang=js"
import style0 from "./PublicOfficialsSection.vue?vue&type=style&index=0&id=c3187f64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3187f64",
  null
  
)

export default component.exports